import { Create, CreateButton, Datagrid, List, NumberInput, SimpleForm, TextField, TextInput, TopToolbar, useNotify, useRedirect } from "react-admin";
import { ItasSearchAllFilter } from "./util/ItasSearchAllFilter";
import { CustomPagination } from "./util/generic";
import { ItasEditActions } from "./util/ItasEditActions";
import { ItasToolbar } from "./util/ItasToolbar";


const ListActions = () => (
    <TopToolbar>
        <CreateButton label="Crea nuova"/>
    </TopToolbar>
);
const required = (message = 'Parametro richiesto') =>
  value => value ? undefined : message;

const CustomBulkActionsToolbar = () => /* bulk action for now */ <></>;

export const TabellaManutenzioniList = (props) => (
    <List 
        filters={ItasSearchAllFilter} 
        perPage={12}
        pagination={<CustomPagination />}
        actions={<ListActions />}
        
    >
      <Datagrid bulkActionButtons={<CustomBulkActionsToolbar />}> 
        <TextField source="codice" />
        <TextField source="descrizione" />
        <TextField source="periodo" />
      </Datagrid>
    </List>
  );

  export const TabellaManutenzioniCreate = () => {
    const notify = useNotify();
    const redirect = useRedirect();
  
    const onSuccess = (data) => {
        notify(`Nuova opzione aggiunta`, { type: 'success' });
        redirect(`/tabella_manutenzioni`);
    };
    return (
      <Create 
        mutationOptions={{ onSuccess }}
        title="Aggiungi nuova opzione">
        <ItasEditActions />
        <TabellaManutenzioniForm />
      </Create>
    );
  }

  const number = (message = 'Deve essere un numero') =>
    value => value && isNaN(Number(value)) ? message : undefined;
  const periodoValidation = (value, allValues) => {
    if (!value) {
        return 'Periodo in mesi necessario';
    }
    if (value < 1) {
        return 'Deve essere almeno maggiore di 1 mese';
    }
    return undefined;
};
const validatePeriodo = [required(), number(), periodoValidation];

  export const TabellaManutenzioniForm = () => {
  
    return (
      <SimpleForm 
        mode="onBlur" 
        reValidateMode="onBlur"
        toolbar={<ItasToolbar />}>
        <TextInput source="codice" validate={required()} fullWidth/>
        <TextInput source="descrizione" validate={required()} fullWidth/>
        <NumberInput source="periodo" validate={validatePeriodo} fullWidth/>
      </SimpleForm>
  )
}